module.exports = __webpack_public_path__ + "static/media/Edgy-StylePicker.02796de5.jpg";